'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
	value: true
});
Object.defineProperty(exports, 'useSelectWallet', {
	enumerable: true,
	get: function get() {
		return _useSelectWallet['default'];
	}
});
var _useSelectWallet = _interopRequireDefault(require('./useSelectWallet'));
//# sourceMappingURL=index.js.map
